module.exports = __webpack_public_path__ + "assets/img/btn-info-d0b2892e.png";